<sharry-header></sharry-header>
<div class="homepage">
  <section
    id="cherry"
    class="homepage__cherry">
    <div class="homepage__cherry__container">
      <div>
        <h3
          class="homepage__cherry__title"
          sharryViewport="fade-in"
          uuid="homepage__cherry__h3"
          [innerHTML]="'homepage.cherry.title' | i18next"></h3>
        <p
          class="bigger"
          sharryViewport="fade-in-1"
          uuid="homepage__cherry__p"
          [innerHTML]="'homepage.cherry.subtitle' | i18next"></p>
      </div>
    </div>
    <div
      sharryViewport="fade-in-1"
      uuid="homepage__cherry__video"
      class="embed homepage__cherry__video"
      sharryVideoLoader>
      <section
        class="sharry__video-embed"
        data-source="youtube"
        data-video-url="https://www.youtube.com/embed/sVLx8VU8ZGY?si=pZLZ_oE4m9KZBgph"
        data-background-image="https://media.sharry.land/app/images/what/pictvideo-spot.webp"></section>
      @if (!isMobile()) {
        <picture
          sharryViewport="fade-in"
          uuid="">
          <source
            media="(max-width: 767px)"
            srcset="https://media.sharry.land/app/images/homepage/italia-naturale-mobile.webp" />
          <img
            height="529"
            width="auto"
            src="https://media.sharry.land/app/images/homepage/italia-naturale-desktop.webp"
            alt="Mappa Italia" />
        </picture>
      }
    </div>
  </section>
  <section class="homepage__explore">
    <h3
      sharryViewport="fade-in"
      uuid="homepage__explore__h3"
      class="homepage__explore__title">
      {{ 'homepage.explore.title' | i18next }}
    </h3>
    <div
      class="homepage__explore__container"
      sharryViewport="fade-in-1"
      uuid="homepage__explore__div">
      <div class="filter-accordion">
        <mat-accordion>
          @for (i of [1, 2, 3]; track i) {
            <mat-expansion-panel
              hideToggle
              [expanded]="expandedIndex === i"
              [disabled]="expandedIndex === i"
              (afterExpand)="onChangeImage(i, 'top')">
              <mat-expansion-panel-header (click)="onChangeExploreBackground()">
                <sharry-icon
                  type="phosphor"
                  [name]="expandedIndex === i ? 'minus' : 'plus'"
                  [svgClass]="'svg-icon' + (expandedIndex === i ? ' svg-icon__active' : '')"></sharry-icon>
                <div class="filter-accordion__title">
                  <h4 [class.filter-accordion__active]="expandedIndex === i">
                    {{ 'homepage.explore.acordion.title-' + i | i18next }}
                  </h4>
                </div>
              </mat-expansion-panel-header>
              <p>{{ 'homepage.explore.acordion.description-' + i | i18next }}</p>
              <div class="filter-accordion__filter-container is-mobile-not-ipad">
                <img
                  alt="mappa"
                  src="https://media.sharry.land/app/images/homepage/esplora/image{{ i }}-area-esplora-768.webp" />
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
      <picture class="is-not-mobile-not-ipad">
        @for (i of [1, 2, 3]; track i) {
          <img
            alt="mappa"
            [ngClass]="{ invisible: expandedIndex !== i }"
            src="https://media.sharry.land/app/images/homepage/esplora/image{{ i }}-area-esplora-1200.webp" />
        }
      </picture>
    </div>
    <br />
    <a
      mat-flat-button
      sharryViewport="fade-in-2"
      uuid="homepage__explore__a"
      color="primary"
      class="rounded sharry-xl"
      [routerLink]="'explore' | routeTranslate"
      >{{ 'homepage.explore.button' | i18next }}</a
    >
  </section>
  <section class="homepage__community">
    <div class="homepage__community__container">
      <div class="homepage__community__background">
        <ng-container [ngTemplateOutlet]="communityDescription"></ng-container>
      </div>
      @for (i of [1, 2]; track i) {
        <picture
          class="homepage__community__picture"
          sharryViewport="fade-in"
          uuid="homepage__community__picture-{{ i }}"
          [ngClass]="{ 'homepage__community__picture--hidden': i !== indexCommunity }">
          <source
            media="(max-width: 767px)"
            srcset="https://media.sharry.land/app/images/homepage/community/foto-ragazz{{i}}-768px.webp" />
          <img
            alt="ragazza con smartphone"
            src="https://media.sharry.land/app/images/homepage/community/foto-ragazz{{ i }}.webp" />
        </picture>
      }
    </div>
    <ng-template #communityDescription>
      <div class="homepage__community__container--description">
        <h3
          class="homepage__community__title"
          sharryViewport="fade-in-1"
          uuid="homepage__community__h3"
          [innerHTML]="'homepage.community.title' | i18next"></h3>
        <p
          class="homepage__community__subtitle"
          sharryViewport="fade-in-2"
          uuid="homepage__community__p"
          [innerHTML]="'homepage.community.subtitle' | i18next"></p>
        <a
          mat-flat-button
          sharryViewport="fade-in-3"
          uuid="homepage__community__a"
          color="primary"
          class="rounded sharry-xl"
          [routerLink]="'community' | routeTranslate"
          >{{ 'homepage.community.button' | i18next }}</a
        >
      </div>
    </ng-template>
  </section>
  <section class="homepage__banner">
    <h3
      class="baloo homepage__banner__title"
      sharryViewport="fade-in">
      {{ 'wonders-map.banner.title' | i18next }}
    </h3>
    <div class="homepage__banner__container">
      <img
        sharryViewport="fade-in-1"
        src="https://media.sharry.land/app/images/trip/Raggruppa2x.png"
        alt="Immagine-wallet-ciliegie" />
      <div
        class="homepage__banner__container__description"
        sharryViewport="fade-in-2">
        <h3
          class="baloo"
          [innerHTML]="'wonders-map.banner.cherrymeter.title' | i18next"></h3>
        <p [innerHTML]="'wonders-map.banner.cherrymeter.desc' | i18next"></p>
        <a
          mat-flat-button
          color="primary"
          class="rounded sharry-medium"
          [routerLink]="'cherry-meter' | routeTranslate">
          {{ 'wonders-map.banner.cherrymeter.button' | i18next }}</a
        >
      </div>
    </div>
  </section>
  <div class="homepage__app-phone">
    <section class="homepage__app">
      <div class="homepage__app__description">
        <p
          sharryViewport="fade-in-1"
          uuid="homepage__app__p">
          {{ 'homepage.app.description' | i18next }}
        </p>
        <div
          class="homepage__app__description--buttons"
          sharryViewport="fade-in-2"
          uuid="homepage__app__div">
          <a
            class="sharry-medium buttons"
            target="_blank"
            href="https://play.google.com/store/apps/details?id=sharry.land.app"
            rel="noopener">
            <sharry-icon
              name="google-play-fill"
              type="custom"
              svgClass="svg-icon"></sharry-icon
            >&nbsp;Google Play
          </a>
          <a
            class="sharry-medium buttons"
            target="_blank"
            href="https://apps.apple.com/it/app/sharryland/id1477462434"
            rel="noopener"
            style="margin-bottom: 1rem">
            <sharry-icon
              name="apple-fill"
              type="custom"
              svgClass="svg-icon"></sharry-icon
            >&nbsp;App Store
          </a>
        </div>
      </div>
      <picture>
        <img
          class="homepage__app__tablet"
          src="https://media.sharry.land/app/images/homepage/community/app/tablet.webp"
          alt="logo" />
      </picture>
    </section>
    <picture>
      <img
        class="homepage__app__phone"
        sharryViewport="fade-in"
        uuid="homepage__app__img"
        src="https://media.sharry.land/app/images/homepage/community/app/iPhone.webp"
        alt="logo" />
    </picture>
  </div>
  <section class="homepage__paladins">
    @if (showPaladins) {
      <div>
        <p
          sharryViewport="fade-in-2"
          uuid="homepage__paladins__title"
          class="homepage__paladins__title"
          [innerHTML]="'homepage.paladins.title' | i18next"></p>
        <p
          sharryViewport="fade-in-2"
          uuid="homepage__paladins__subtitle"
          class="homepage__paladins__subtitle"
          [innerHTML]="'homepage.paladins.subtitle' | i18next"></p>
        <div
          class="homepage__paladins__container"
          sharryViewport="fade-in-2"
          uuid="homepage__paladins__container">
          <img
            src="https://media.sharry.land/app/images/homepage/giordano-dell-amore.webp"
            alt="logo-giordano-dell-amore" />
          <img
            src="https://media.sharry.land/app/images/homepage/itas.webp"
            alt="logo-itas" />
          <img
            src="https://media.sharry.land/app/images/homepage/LOGO-fondazione-cariplo.png"
            alt="logo-trevisan-macchine-utensili" />
        </div>
      </div>
    }
    <p
      sharryViewport="fade-in-2"
      uuid="homepage__paladins__about-us-title"
      class="homepage__paladins__about-us-title"
      [innerHTML]="'homepage.paladins.about-us-title' | i18next"></p>
    <div
      class="homepage__paladins__container--about-us"
      sharryViewport="fade-in-2"
      uuid="homepage__paladins__container--about-us">
      <a
        href="https://mediasetinfinity.mediaset.it/video/eplanet/lapp-per-il-turismo-lento_F312329501005C05"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/Mediaset_Infinity_logo.webp"
          alt="logo-mediaset-infinity" />
      </a>
      <a
        href="https://info.sharry.land/it/pdf/corriere-della-sera-9-12-2023.webp"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/Corriere-della-Sera.webp"
          alt="logo-corriere-della-sera" />
      </a>
      <a
        href="https://www.repubblica.it/viaggi/2023/10/12/news/aree_interne_italiane_in_nuova_mappa_digitale-417601122/"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/La_Repubblica.webp"
          alt="logo-la-repubblica" />
      </a>
      <a
        href="https://info.sharry.land/it/pdf/29122023-QN-QNSETTIMANALI-WEEKEND.webp"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/quotidiano-nazionale-itinerari.webp"
          alt="logo-quotidiano-nazionale" />
      </a>
      <a
        href="https://www.ilsole24ore.com/art/borghi-startup-che-scommette-sull-impatto-turismo-rurale-AEczJskB?fbclid=IwAR1KsDK1-Y6X6Ds61cNqTHmTPvdzQZ_rT9xwdOp4j5-4cIIYQJbXofSH4js"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/ilsole24ore-o-2021.svg"
          alt="logo-sole-24-ore" />
      </a>
      <a
        href="https://www.wired.it/economia/start-up/2019/11/22/sharryland-weekend/"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/logo-wired.svg"
          alt="logo-wired" />
      </a>
    </div>
  </section>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
